module.exports = __webpack_public_path__ + "img/sea-3.cc7b4281.jpg";